// extracted by mini-css-extract-plugin
export default {"screen":"Audio_screen__Nf+M5","logo":"Audio_logo__A33k3","body":"Audio_body__UOBCG","headerBox":"Audio_headerBox__uDf8x"};